import ndAuthentication from 'nd.authentication';
import ndLogger from 'nd.logger';
import ndUser from 'nd.user';

/*
    Default view model for LandingPage template.
    Please, update the following documentation after modifying this view model:
    https://pressreader.atlassian.net/wiki/spaces/BE/pages/2568356010/SE2Sky+LandingPageViewModel+for+LandingPage+template
*/

class LandingPageViewModel {
    isLoggedIn: KnockoutObservable<boolean>;

    constructor() {
        this.isLoggedIn = ko.observable(ndUser.isLogin());
        ndUser.onUserStateChanged(() => {
            this.isLoggedIn(ndUser.isLogin());
        });
    }

    public async showSignInDialog(): Promise<void> {
        try {
            await ndAuthentication.signIn();
        } catch (e) {
            if (e?.userCancelled) {
                return;
            }
            ndLogger.error(e);
        } finally {
            // Redirection occours only if the user is authenticated in our platform
            // as it may be using external auth providers, auth flow may be completed / incompleted / failed or redirected
            // but only successfuly when it was able to authenticate the user in our side.
            // This also protects for wrong usage of this API in the UI.
            if (ndUser.isLogin()) {
                ndUser.redirectTo('OnSigningIn');
            }
        }
    }

    public signout() {
        ndAuthentication.signOut();
    }
}

export default LandingPageViewModel;
